import { createContainer } from 'react-sweet-state';
import { TourDescriptionStoreDefault, TourDescriptionStoreFrame } from './TourDescriptionStore';
let g_desription_store_hydrated = false;
const CreateTourDescriptionContainer = (store) => createContainer(store, {
    onInit: () => ({ getState, setState, dispatch }, { initialState: init }) => {
        var _a, _b, _c, _d, _e, _f;
        if (init)
            setState({ flightConfiguration: init.flightConfiguration });
        if (init && init.type == 'description-state' && init.description && !g_desription_store_hydrated) {
            g_desription_store_hydrated = true;
            // FIXME: duplicating loadDescription.
            const hotelServices = init.description.tourServices.filter((x) => x.type == 'hotel');
            if (hotelServices.length == 0) {
                setState({ currentAccommodationVariants: [], hasAccommodation: false, });
            }
            else {
                setState({
                    currentAccommodationVariants: hotelServices.map(hotel => ({
                        accommodation: hotel.accommodation,
                        hotelDescription: hotel.hotelDescription,
                        externalHotelPrice: hotel.externalHotelPrice
                    })),
                    hasAccommodation: true,
                });
            }
            //if (hotelServices.length == 1) {
            //    const hotel = hotelServices[0];
            //    const accommodation = hotel.accommodation || undefined;
            //    setState({
            //        currentAccommodationVariant: {
            //            accommodation,
            //            hotelDescription: hotel.hotelDescription,
            //        },
            //        hasAccommodation: true
            //    });
            //} else if (hotelServices.length == 0) {
            //    setState({ currentAccommodationVariant: undefined, hasAccommodation: false });
            //} else if (hotelServices.length > 1) {
            //    setState({ currentAccommodationVariant: undefined, hasAccommodation: true });
            //    //throw new Error('Unexpected number of hotel services');
            //}
            const { viewConfig } = getState();
            setState({
                loaded: true,
                loading: false,
                tourDescription: init.description.tourDescription,
                price: init.description.priceItem,
                hash: (_a = init.description.priceItem) === null || _a === void 0 ? void 0 : _a.servicesHash,
                externalFlightId: ((_c = (_b = init.description.priceItem) === null || _b === void 0 ? void 0 : _b.aviacenterServices) === null || _c === void 0 ? void 0 : _c.length) ? init.description.priceItem.aviacenterServices[0].externalId : undefined,
                externalFlightProviderId: ((_e = (_d = init.description.priceItem) === null || _d === void 0 ? void 0 : _d.aviacenterServices) === null || _e === void 0 ? void 0 : _e.length) ? init.description.priceItem.aviacenterServices[0].externalProviderId : undefined,
                tourEvents: init.description.tourEvents,
                tourServices: init.description.tourServices,
                tourVariant: init.description.tourVariant || undefined,
                viewConfig: Object.assign(Object.assign({}, viewConfig), { hidePrices: init.hidePrices || false }),
                extras: (_f = init.description.extras) !== null && _f !== void 0 ? _f : {},
                search: init.description.search,
            });
            const { tourServices, tourVariant, tourDescription, currentAccommodationVariants } = getState();
            if (tourVariant && tourVariant.checkInDate && tourDescription)
                //setState({ loading: true });
                for (const excursion of tourServices.filter(s => s.type == "excursion").map(s => s)) {
                    setState({
                        tourServices: [...tourServices].map(service => {
                            var _a, _b, _c, _d, _e, _f, _g;
                            if (service.type == "excursion" && service.id == excursion.id) {
                                const exc = service;
                                if (exc) {
                                    exc.prices = excursion.prices;
                                    const vehicleTypeId = (_b = (_a = excursion.prices) === null || _a === void 0 ? void 0 : _a.find((x) => x)) === null || _b === void 0 ? void 0 : _b.vehicleTypeId;
                                    if ((_c = exc.prices) === null || _c === void 0 ? void 0 : _c.length) {
                                        if (!((_d = exc.prices) === null || _d === void 0 ? void 0 : _d.find((e) => exc.currentVehicleTypeId == e.vehicleTypeId)) || exc.currentVehicleTypeId == undefined) {
                                            exc.currentVehicleTypeId = (_f = (_e = exc.prices[0]) === null || _e === void 0 ? void 0 : _e.vehicleTypeId) !== null && _f !== void 0 ? _f : vehicleTypeId;
                                            exc.excursionPrice = exc.prices ? exc.prices[0] : undefined;
                                        }
                                        else
                                            exc.excursionPrice = (_g = exc.prices) === null || _g === void 0 ? void 0 : _g.find((x) => x.vehicleTypeId == exc.currentVehicleTypeId);
                                    }
                                }
                            }
                            return service;
                        })
                    });
                }
        }
    },
});
/**
 * Контейнер выполняющий функцию регидратации хранилища с описанием тура.
 */
const Container = CreateTourDescriptionContainer(TourDescriptionStoreDefault);
const FrameContainer = CreateTourDescriptionContainer(TourDescriptionStoreFrame);
export { Container as TourDescriptionStoreContainer, FrameContainer as TourDescriptionStoreFrameContainer };
